import {
    paramDsNameDest,
    paramDsNameSrc,
    paramXPathSrc,
    paramXpathDest,
} from '../constants/parameterNames';
import { typeDataSource, typeXPath } from '../constants/parameterTypes';
import { success } from '../helpers/commandResult';
import { getParamValue } from '../helpers/parameter.accessors';
import { getDataSource } from '../helpers/qRules.dataSource.helpers';
import { getValidNode } from '../helpers/qRules.node.helpers';

const optionalParameters = [
    {
        name: paramDsNameSrc,
        description: 'Data Source Name (Source)',
        type: typeDataSource,
    },
    {
        name: paramDsNameDest,
        description: 'Data Source Name (Destination)',
        type: typeDataSource,
    },
];

const requiredParameters = [
    {
        name: paramXPathSrc,
        description: 'XPath to Node (Source)',
        type: typeXPath,
        dsParentName: 'dsnamesrc',
    },
    {
        name: paramXpathDest,
        description: 'XPath to Node (Destination)',
        type: typeXPath,
        dsParentName: 'dsnamedest',
    },
];

const copyRichTextErrorFailedToSelectSourceNode =
    'Failed to select the source node to copy from.';
const copyRichTextErrorFailedToSelectDestinationNode =
    'Failed to select the destination node to copy to.';
const description =
    'Copies a rich text field. You can specify a destination and a source data source as well as the XPath to a rich-text field you wish to copy.';

const executeAsync = async ({ dataSources, parameters }) => {
    const dsnamesrc = getParamValue(parameters, paramDsNameSrc);
    const xpathsrc = getParamValue(parameters, paramXPathSrc);
    const dsnamedest = getParamValue(parameters, paramDsNameDest);
    const xpathdest = getParamValue(parameters, paramXpathDest);
    const domSource = getDataSource(dataSources, dsnamesrc);
    const domDest = getDataSource(dataSources, dsnamedest);

    const srcNode = getValidNode(
        domSource,
        xpathsrc,
        copyRichTextErrorFailedToSelectSourceNode,
    );
    const destNode = getValidNode(
        domDest,
        xpathdest,
        copyRichTextErrorFailedToSelectDestinationNode,
    );

    const rtNodes = srcNode.getNode().childNodes;

    await destNode.setValueAsync(rtNodes, { isRichTextXml: true });

    return success();
};

const CopyRichText = {
    description,
    executeAsync,
    optionalParameters,
    requiredParameters,
};

export default CopyRichText;
